import Alpine from "alpinejs";
import { format, validate } from 'rut.js'
import Swiper from 'swiper'
import {
  Navigation as SwiperNav,
  Pagination,
  Autoplay,
  Thumbs,
  FreeMode,
} from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'
import 'swiper/css/thumbs'
import 'swiper/css/free-mode'

window.Autoplay = Autoplay
window.SwiperNav = SwiperNav
window.Thumbs = Thumbs
window.Pagination = Pagination
window.FreeMode = FreeMode
window.Swiper = Swiper

window.Alpine = Alpine;
window.formatRut = format;
window.validateRut = validate;

Alpine.start();